import React from 'react';
import { Card, CardContent, Typography, Stack, TextField, Button } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface StartLessonCardProps {
  onStartLesson: (title: string) => void;
}

interface FormInputs {
  title: string;
}

const StartLessonCard: React.FC<StartLessonCardProps> = ({ onStartLesson }) => {
  const { control, handleSubmit, reset } = useForm<FormInputs>({
    defaultValues: { title: '' },
  });

  const onSubmit = (data: FormInputs) => {
    onStartLesson(data.title);
    reset();
  };

  return (
    <Card sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', p: 1.5 }}>
      <CardContent sx={{ pb: '16px !important' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
          Start a New Session
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Lesson Topic/Title (Optional)"
                  placeholder="e.g. Shopping or Greetings"
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              )}
            />
            <Button
              type="submit"
              variant="contained"
              startIcon={<PlayArrowIcon />}
              sx={{ borderRadius: 3, fontWeight: 'bold' }}
            >
              Start Lesson with Sven
            </Button>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
};

export default StartLessonCard;
